<template>
  <div class="oneui">
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.themes')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page" style="padding-bottom: 30px">
        <div class="ul">
          <div class="li" v-for="theme in themes" :key="theme" @click="setTheme(theme)">
            <span>{{$t(`pages.settings.themeNames.${theme}`)}}</span>
            <span :class="currentTheme == theme ? 'fhr fhr-circle-check' : 'fhr fhr-circle'"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
/* JS IMPORTS */
import * as CCDb from "../../utilities/db";

export default {
  data() {
    return {
      currentTheme: "",
      themes: [
        "sky-blue",
        "vib-cools",
        "soft-cools",
        "peach",
        "light-pumpkin",
        "teal",
        "green",
        "red"
      ]
    };
  },
  methods: {
    async setTheme(className) {
      const profile = await CCDb.getUserProfile();
      profile.set("theme", className);
      await profile.save();
      $("html").attr("theme", className);
      this.currentTheme = className;
    }
  },
  async mounted() {
    let _this = this;
    const profile = await CCDb.getUserProfile();
    this.$data.currentTheme = profile ? profile.get("theme") : null;
  }
};
</script>

